import styled from 'styled-components'

export const StyledDisabledText = styled.div`
  color: ${({ theme }) => theme.colors.GREY_470};
  font-size: 0.75rem;
  line-height: 1.125rem;
`
